import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import GridItem from 'components/Grid/GridItem';
import { wsGetAll } from 'services/WService';

const useStyles = makeStyles({
  title: {
    fontSize: '13px',
    fontWeight: '500',
  },
  value: {
    whitSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
});

function ReadItem({ classes, title, value }) {
  return (
    <>
      <span className={classes.title}>{title}</span>
      <p className={classes.value}>{value}</p>
    </>
  );
}

function PurchaseHeaderData(props) {
  const classes = useStyles();
  const { bpId, setBpId } = props;
  const { warehouseId, setWarehouseId } = props;
  const { ncType, setNcType } = props;
  const { ncSerie, setNcSerie } = props;
  const { ncNumber, setNcNumber } = props;
  const { comments, setComments } = props;
  const { DocType, processing, refPurchase } = props;

  const [providers, setProviders] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  async function listProviders() {
    let res = await wsGetAll('base/business-partner?CardType=S&QryGroup1=Y');
    if (res.success) {
      setProviders(res.data);
    }
  }

  async function listWarehouses() {
    let res = await wsGetAll('logi/warehouse');
    if (res.success) {
      setWarehouses(res.data);
    }
  }

  useEffect(() => {
    listProviders();
    listWarehouses();
  }, []);

  useEffect(() => {
    if (refPurchase?.CardCode && providers.length > 0) {
      const providerFound = providers.find((provider) => provider.CardCode === refPurchase.CardCode);
      if (providerFound && providerFound.id !== bpId) {
        setBpId(providerFound.id);
      }
    }
  }, [refPurchase, providers, bpId]);
  return (
    <GridContainer>
      <GridItem xs={12}>
        <h5 style={{ fontWeight: 400 }}>Nota de débito</h5>
      </GridItem>
      <GridItem xs={12}>
        <GridContainer>
          {/* Tipo documento */}
          <GridItem xs={12} md={4} lg={2}>
            <FormControl fullWidth margin="normal" size="small" required={DocType === 'I'}>
              <InputLabel shrink>Tipo documento</InputLabel>
              <Select
                defaultValue=""
                inputProps={{ name: 'U_SYP_MDTD' }}
                value={ncType}
                onChange={(e) => setNcType(e.target.value)}
                required
                disabled={processing}
              >
                <MenuItem value="07">Nota de débito</MenuItem>
                {/* <MenuItem value="03">Boleta</MenuItem> */}
              </Select>
            </FormControl>
          </GridItem>
          {/* Serie */}
          <GridItem xs={12} md={4} lg={2}>
            <TextField
              label="Serie"
              fullWidth
              name="U_SYP_MDSD"
              margin="normal"
              size="small"
              required
              InputLabelProps={{
                shrink: true,
              }}
              value={ncSerie}
              onChange={(e) => setNcSerie(e.target.value)}
              disabled={processing}
            />
          </GridItem>
          {/* Código */}
          <GridItem xs={12} md={4} lg={2}>
            <TextField
              label="Número"
              fullWidth
              name="U_SYP_MDCD"
              margin="normal"
              size="small"
              required
              InputLabelProps={{
                shrink: true,
              }}
              value={ncNumber}
              onChange={(e) => setNcNumber(e.target.value)}
              disabled={processing}
            />
          </GridItem>
          {/* Almacén */}
          <GridItem xs={12} md={4} lg={2}>
            <Autocomplete
              options={warehouses}
              getOptionLabel={(option) => option.WhsName}
              value={warehouses.find((provider) => provider.id === warehouseId) || null}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{ shrink: true, ...params.InputLabelProps }}
                  fullWidth
                  label="Almacén"
                  margin="normal"
                  required
                />
              )}
              onChange={(e, item) => {
                if (!!item) {
                  return setWarehouseId(item.id);
                }
                setWarehouseId(undefined);
              }}
            />
          </GridItem>
          {/* Proveedor */}
          {/* {DocType === 'S' && ( */}
          {/* )} */}
          {/* Comentario */}
          {/* {DocType === 'S' && ( */}
            <GridItem xs={12} md={4} lg={2}>
              <TextField
                label="Comentario"
                fullWidth
                name="Comments"
                margin="normal"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                disabled={processing}
              />
            </GridItem>
            <GridItem xs={12} md={4} lg={2}>
              <Autocomplete
                style={{ display: 'none' }}
                options={providers}
                getOptionLabel={(option) => option.CardName}
                value={providers.find((provider) => provider.id === bpId) || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputLabelProps={{ shrink: true, ...params.InputLabelProps }}
                    label="Proveedor"
                    margin="normal"
                    required
                  />
                )}
                onChange={(e, item) => {
                  if (item) {
                    return setBpId(item.id);
                  }
                  setBpId(undefined);
                }}
                // disabled={true}
              />
            </GridItem>

        </GridContainer>
      </GridItem>
      {refPurchase.DocEntry !== undefined && (
        <>
          <GridItem xs={12} md={4} lg={2}>
            <ReadItem
              classes={classes}
              title="Zona"
              value={refPurchase.purchase?.base_zone_description || ''}
            />
          </GridItem>
          <GridItem xs={12} md={4} lg={2}>
            <ReadItem
              classes={classes}
              title="Almacén"
              value={refPurchase.purchase?.WhsName || ''}
            />
          </GridItem>
          <GridItem xs={12} md={4} lg={2}>
            <ReadItem classes={classes} title="Cod Proveedor" value={refPurchase.CardCode} />
          </GridItem>
          <GridItem xs={12} md={4} lg={2}>
            <ReadItem classes={classes} title="Proveedor" value={refPurchase.CardName} />
          </GridItem>
          <GridItem xs={12} md={4} lg={2}>
            <ReadItem classes={classes} title="Dirección" value={refPurchase.Address} />
          </GridItem>
          <GridItem xs={12} md={4} lg={2}>
            <ReadItem classes={classes} title="Monto" value={refPurchase.PaidToDate} />
          </GridItem>
        </>
      )}
    </GridContainer>
  );
}

export default PurchaseHeaderData;
